import { Component, OnInit, ElementRef } from '@angular/core';
import { Platform, NavController, MenuController, AngularDelegate } from '@ionic/angular';
import { CommonDeclarationService } from 'src/app/service/common/common-declaration.service';
import { RestapiService } from 'src/app/service/api/restapi.service';
import { CommonDefinitionService } from 'src/app/service/common/common-definition.service';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { Camera, CameraOptions } from '@ionic-native/camera/ngx';
import { File } from '@ionic-native/file/ngx';
import { ActionSheetController } from '@ionic/angular';
import { ActionlistenService } from 'src/app/service/actionlisten.service';
import { Base64 } from '@ionic-native/base64/ngx';
import { FilePath } from '@ionic-native/file-path/ngx';
import { FileChooser } from '@ionic-native/file-chooser/ngx';
import { IOSFilePicker } from '@ionic-native/file-picker/ngx';
import { DomSanitizer } from '@angular/platform-browser';
import { StatusBar } from '@ionic-native/status-bar/ngx';

@Component({
  selector: 'app-emailupdate',
  templateUrl: './emailupdate.page.html',
  styleUrls: ['./emailupdate.page.scss'],
})
export class EmailupdatePage implements OnInit {

  myStyles: Object = {};

  headingtitle: any;
  emailID: any;
  langcontext: any;
  emailupdateForm: any = FormGroup;
  formsubmitted: any;
  mobileno: any;
  newemailID: any;
  reemailId: any;
  seltype: any;
  selproof: any;
  TypeJson: any;
  PageUrl: any;
  emailupdateForm1: any;
  ProofImg: any;
  TrustFrontImgFile: any;
  TrustBackImgFile: any;
  FrontImgFile: any;
  BackImgFile: any;
  FronImgName: any;
  BackImgName: any;
  agreecheck: any = false;
  FileSelected: any;
  Filearray: any;

  imagePickerOptions = {
    maximumImagesCount: 1,
    quality: 50
  };

  constructor(public platform: Platform, private el: ElementRef, public menuCtrl: MenuController, public actionVal: ActionlistenService, public camera: Camera, public file: File, public actionSheetController: ActionSheetController, public router: Router, public navCtrl: NavController, public formBuilder: FormBuilder, public cmndecl: CommonDeclarationService, public cmndef: CommonDefinitionService, public api: RestapiService, public base64: Base64, public filePath: FilePath, public fileChooser: FileChooser, public _DomSanitizer: DomSanitizer, public iosfilepicker: IOSFilePicker, public statusBar: StatusBar) {
    this.emailID = "";
    this.TypeJson = [];
    this.Filearray = [];
    this.TrustBackImgFile = 'assets/images/aadhaar.png';
    this.TrustBackImgFile = 'assets/images/aadhaar.png';
    this.PageUrl = this.router.url;
    console.log("this is the page url" + this.PageUrl);
    this.emailupdateForm = formBuilder.group({
      newemailId: ['', Validators.compose([
        Validators.required,
        Validators.pattern('[A-Za-z0-9-!#$%&*+./?^_`{}|]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}')])],
      reemailId: ['', Validators.compose([
        Validators.required,
        Validators.pattern('[A-Za-z0-9-!#$%&*+./?^_`{}|]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}')])],
      seltype: ['', Validators.required]
    });

    this.emailupdateForm1 = formBuilder.group({
      newemailId: ['', Validators.compose([
        Validators.required,
        Validators.pattern('[A-Za-z0-9-!#$%&*+./?^_`{}|]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}')])],
      reemailId: ['', Validators.compose([
        Validators.required,
        Validators.pattern('[A-Za-z0-9-!#$%&*+./?^_`{}|]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}')])],
      seltype: ['', Validators.required],
      selproof: ['', Validators.required],
      agreecheck: []
    });

    if (this.cmndecl.LanguageJson) {
      this.langcontext = this.cmndecl.LanguageJson.pages[0]['email_update'];
    } else {
      this.cmndecl.LanguageJson = JSON.parse(localStorage.languageJson);
      this.langcontext = this.cmndecl.LanguageJson['pages'][0].email_update;
    }
    this.headingtitle = this.langcontext.heading.text;
    this.getEmailData();
  }

  ngOnInit() {
    this.cmndef.emailScreenRedirection = true;
    console.log(this.cmndef.emailScreenRedirection);
  }


  checkUserEmail() {
    if (this.newemailID != undefined && this.reemailId != undefined) {
      if (this.newemailID.toUpperCase() == this.reemailId.toUpperCase())
        return false;
      else
        return true;
    } else
      return true;

  }


  ionViewWillEnter() {
    this.menuCtrl.swipeEnable(false);
  }

  imgs() {
    this.FronImgName = "";
    this.FrontImgFile = "";
    this.BackImgFile = "";
    this.BackImgName = "";
    this.agreecheck = false;
    if (this.selproof == "Aadhaar") {
      this.TrustFrontImgFile = 'assets/images/aadhaar.png';
      this.TrustBackImgFile = 'assets/images/aadhaar.png';
    }
    else if (this.selproof == "Voter Id") {
      this.TrustFrontImgFile = 'assets/images/voter-id-card.png';
      this.TrustBackImgFile = 'assets/images/voterback.png';
    }
    else if (this.selproof == "Driving License") {
      this.TrustFrontImgFile = 'assets/images/drive.png';
      this.TrustBackImgFile = 'assets/images/driveback.png';
    }
    else if (this.selproof == "PAN Card") {
      this.TrustFrontImgFile = 'assets/images/panuploadIcon.PNG';
    }
    else if (this.selproof == "NREGA Job Card") {
      this.TrustFrontImgFile = 'assets/images/naregasample.png';
      this.TrustBackImgFile = 'assets/images/naregasample1.png';
    }
    else if (this.selproof == "Passport") {
      this.TrustFrontImgFile = 'assets/images/passportfront.jfif';
      this.TrustBackImgFile = 'assets/images/passportback.jpg';
    }
    else {
      this.TrustFrontImgFile = 'assets/images/other.png';
    }
  }

  async getEmailData() {
    let profile: any;
    let req: any;
    let res: any;
    await this.cmndef.loaderstart();
    req = {
      "mobileNo": localStorage.user,
      "requestType": "getProfileData",
      "userSessionID": localStorage.userSessionID,
      "userChatSessionId": localStorage.userChatSessionId,
    }

    await this.api.postapi("updateDetails", req).then(async data => {
      res = data;
      this.emailID = res.emailID;
      this.mobileno = res.mobileNo;
      this.cmndecl.storeProcess(res, "profile");
      await this.cmndef.loaderend();
    }, async err => {
      await this.cmndef.loaderend();
    });
  }

  SendOtpscreen() {
    let req: any;
    let res: any;
    let EmailData = {
      "emailID": this.newemailID,
      "emailType": this.seltype
    }
    this.cmndef.vasNewEmailId = this.newemailID;

    if (this.emailupdateForm.valid && this.newemailID.toUpperCase() == this.reemailId.toUpperCase()) {
      this.cmndecl.DataStore = {
        "EmailDetails": EmailData,
        "ProofType": "",
        "actionType": "EMAIL_UPDATE",
        "fileContent": "",
        "verficationType": "",
        "userSessionID": localStorage.userSessionID,
        "userChatSessionID": localStorage.userChatSessionId,
      };
      req = {
        actionType: "OTPREQUEST",
        userChatSessionID: localStorage.userChatSessionId,
        userSessionID: localStorage.userSessionID
      }
      this.api.clickenventcap("submit_" + this.cmndef.TrakcerFromValue[this.cmndef.router.url]);
      this.api.postapi("otpRequest", req).then(data => {
        res = data;
        if (this.emailID != "" && this.emailID != undefined && this.mobileno != "" && this.mobileno != undefined)
          this.cmndef.Showtoast(this.langcontext.otpsendreq.error);
        else if (this.emailID != "" && this.emailID != undefined)
          this.cmndef.Showtoast(this.langcontext.otpsendmailid);
        else
          this.cmndef.Showtoast(this.langcontext.otpsendmobno);

        localStorage.state = res.state;
        this.cmndef.previousPage = this.PageUrl;
        sessionStorage.CurrentPage = "/verifyemailOtpupdate";
        this.navCtrl.navigateForward("/verifyemailOtpupdate")
      }, err => {
        console.log(err);
      })
    }
  }

  async raiseTicket() {
    let EmailData = {
      "emailID": this.newemailID,
      "emailType": this.seltype
    }
    this.Filearray = [];
    if ((this.selproof == "Aadhaar" && this.agreecheck == false))
      return;
    if (this.selproof == "Aadhaar" || this.selproof == "Driving License" || this.selproof == "Voter Id" || this.selproof == "Passport" || this.selproof == "NREGA Job Card") {
      this.Filearray = [];
      if (this.FrontImgFile != '' && this.FrontImgFile != undefined && this.BackImgName != '' && this.BackImgName != undefined) {
        this.Filearray.push({
          "fileContent": this.FrontImgFile,
          "fileContentName": this.FronImgName,
          "fileType": "image/jpeg"
        });
        this.Filearray.push({
          "fileContent": this.BackImgFile,
          "fileContentName": this.BackImgName,
          "fileType": "image/jpeg"
        })
      }
    } else {
      if (this.FrontImgFile != '' && this.FrontImgFile != undefined) {
        this.Filearray.push({
          "fileContent": this.FrontImgFile,
          "fileContentName": this.FronImgName,
          "fileType": "image/jpeg"
        });
      }
    }
    console.log(this.Filearray);
    if (this.emailupdateForm1.valid && this.newemailID == this.reemailId && (((this.selproof == 'Driving License' || this.selproof == 'Aadhaar' || this.selproof == "Voter Id" || this.selproof == "Passport" || this.selproof == "NREGA Job Card") && this.Filearray.length == 2) || this.Filearray.length == 1)) {
      await this.cmndef.loaderstart();
      this.cmndecl.DataStore = {
        "EmailDetails": EmailData,
        "ProofType": this.selproof,
        "actionType": "EMAIL_UPDATE",
        "fileContent": this.Filearray,
        "verficationType": "IDProof",
        "userSessionID": localStorage.userSessionID,
        "userChatSessionID": localStorage.userChatSessionId,
      };

      console.log(this.cmndecl.DataStore);

      this.api.clickenventcap("submit_" + this.cmndef.TrakcerFromValue[this.cmndef.router.url]);
      await this.api.postapi("akeiraVAAction", this.cmndecl.DataStore).then(async data => {
        let res = data;
        this.cmndef.loaderend();
        this.cmndecl.TamlismaJson = res["chatResp"][0];
        sessionStorage.CurrentPage = "/va/chat";
        this.navCtrl.navigateForward("/va/chat");
      })
    }
  }

  pickImage(sourceType) {
    let date = new Date();

    const options: CameraOptions = {
      quality: localStorage.imagequality,
      sourceType: sourceType,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE
    }
    this.camera.getPicture(options).then(async (imageData) => {
      if (this.platform.is('ios')) {
        await this.statusBar.overlaysWebView(true);
        await this.statusBar.overlaysWebView(false);
      }
      let base64Image = 'data:image/jpeg;base64,' + imageData;
      let stringLength: number = Number(imageData.length);
      let sizeInBytes = 4 * Math.ceil((stringLength / 3)) * 0.5624896334383812;
      let sizeInMB = sizeInBytes / 1000000;
      if (Math.floor(sizeInMB) <= Number(localStorage.imgsize)) {
        if (imageData.indexOf("file:/") != -1) {
          this.base64.encodeFile(imageData).then((base64File: string) => {
            if (this.FileSelected == "front") {
              this.FronImgName = imageData.substring(imageData.lastIndexOf("/") + 1, imageData.length);
              this.TrustFrontImgFile = this._DomSanitizer.bypassSecurityTrustUrl(base64File);
              this.FrontImgFile = base64File;
            } else {
              this.BackImgName = imageData.substring(imageData.lastIndexOf("/") + 1, imageData.length);
              this.BackImgFile = base64File;
              this.TrustBackImgFile = this._DomSanitizer.bypassSecurityTrustUrl(base64File);
            }
          });
        } else {
          if (this.FileSelected == "front") {
            this.FronImgName = "IMG_" + date.getFullYear() + date.getMonth() + date.getDate() + date.getHours() + date.getMinutes() + date.getSeconds() + date.getMilliseconds() + ".jpeg",
            this.TrustFrontImgFile = this._DomSanitizer.bypassSecurityTrustUrl(base64Image);
            this.FrontImgFile = base64Image;
          } else {
            this.BackImgName = "IMG_" + date.getFullYear() + date.getMonth() + date.getDate() + date.getHours() + date.getMinutes() + date.getSeconds() + date.getMilliseconds() + ".jpeg",
            this.TrustBackImgFile = this._DomSanitizer.bypassSecurityTrustUrl(base64Image);
            this.BackImgFile = base64Image;
          }
        }
      }else{
        this.cmndef.presentAlert("", this.cmndecl.LanguageJson.pages[0]['alerts'].maxfilesizalwd + " "+localStorage.imgsize+"MB", "invalid");
      }
    }, async(err) => {
      if (this.platform.is('ios')) {
          await this.statusBar.overlaysWebView(true);
          await this.statusBar.overlaysWebView(false);
        }
  });
  }

  async selectImage(flg: any) {
    this.FileSelected = flg;
    this.cmndecl.Actionsheetenable = true;
    const actionSheet = await this.actionSheetController.create({
      header: "Select Image source",
      buttons: [{
        text: 'Load from Library',
        handler: () => {
          this.cmndecl.Actionsheetenable = false;
          if (this.cmndecl.runPlatform == 'ios')
            this.IOSFileselect();
          else
            this.Fileselect();
        }
      },
      {
        text: 'Use Camera',
        handler: () => {
          this.cmndecl.Actionsheetenable = false;
          this.pickImage(this.camera.PictureSourceType.CAMERA);
        }
      },
      {
        text: 'Cancel',
        role: 'cancel',
        handler: () => {
          this.cmndecl.Actionsheetenable = false;
        }
      }
      ]
    });
    await actionSheet.present();
  }

  async IOSFileselect() {
    let filePath: any;
    let fileName: any;
    let path: any;
    let validFormate: any;
    let stringLength: any;
    await this.iosfilepicker.pickFile().then(async uri => {
      filePath = "file://" + uri;
      fileName = filePath.split('/').pop();
      path = filePath.substring(0, filePath.lastIndexOf("/") + 1);
      this.file.readAsDataURL(path, fileName).then(base64File => {
        sessionStorage.demo = base64File;
        validFormate = fileName.substring(fileName.lastIndexOf("."), fileName.length);
        if (validFormate.toLowerCase() == ".jpg" || validFormate.toLowerCase() == ".jpeg" || validFormate.toLowerCase() == ".pdf" || validFormate.toLowerCase() == ".tiff" || validFormate.toLowerCase() == ".png") {
          stringLength = base64File.substring(base64File.indexOf("64,") + 3, base64File.length);
          stringLength = stringLength.length;
          console.log(stringLength);
          let sizeInBytes = 4 * Math.ceil((stringLength / 3)) * 0.5624896334383812;
          let sizeInMB = sizeInBytes / 1000000;
          if (Math.round(sizeInMB) <= Number(localStorage.imgsize)) {
            if (this.FileSelected == "front") {
              this.FronImgName = fileName;
              this.FrontImgFile = base64File;
              if (validFormate.toLowerCase() == ".pdf")
                this.TrustFrontImgFile = "assets/images/pdfimg.PNG"
              else
                this.TrustFrontImgFile = this._DomSanitizer.bypassSecurityTrustUrl(base64File);
            } else {
              this.BackImgName = fileName;
              this.BackImgFile = base64File;
              if (validFormate.toLowerCase() == ".pdf")
                this.TrustBackImgFile = "assets/images/pdfimg.PNG"
              else
                this.TrustBackImgFile = this._DomSanitizer.bypassSecurityTrustUrl(base64File);
            }
          } else
            this.cmndef.presentAlert("", this.cmndecl.LanguageJson.pages[0]['alerts'].maxfilesizalwd + " "+localStorage.imgsize+"MB", "invalid");
        } else
          this.cmndef.presentAlert("", this.cmndecl.LanguageJson.pages[0]['alerts'].invalidImage, "invalid");
      })
        .catch(() => {
          console.log('Error reading file');
        })
    })
      .catch(err => console.log('Error', err));
  }

  Fileselect() {
    let validFormate: any;
    let stringLength: any;
    if (this.platform.is('android')) {
      this.fileChooser.open()
        .then(
          uri => {
            this.filePath.resolveNativePath(uri)
              .then(url => {
                var fileName = url.substring(url.lastIndexOf("/") + 1);

                validFormate = url.substring(url.lastIndexOf("."), url.length);
                console.log(validFormate);
                if (validFormate.toLowerCase() == ".jpg" || validFormate.toLowerCase() == ".jpeg" || validFormate.toLowerCase() == ".pdf" || validFormate.toLowerCase() == ".tiff" || validFormate.toLowerCase() == ".png") {
                  this.base64.encodeFile(url).then((base64File: string) => {
                    if (validFormate.toLowerCase() == ".pdf") {
                      stringLength = base64File.indexOf("64,") + 3;
                      base64File = "data:application/pdf;base64," + base64File.substring(stringLength, base64File.length);
                      stringLength = base64File.length - 'data:application/pdf;base64,'.length;
                    } else
                      stringLength = base64File.length - 'data:image/png;base64,'.length;

                    let sizeInBytes = 4 * Math.ceil((stringLength / 3)) * 0.5624896334383812;
                    let sizeInMB = sizeInBytes / 1000000;
                    if (Math.round(sizeInMB) <= Number(localStorage.imgsize)) {
                      if (this.FileSelected == "front") {
                        this.FronImgName = fileName;
                        if (validFormate.toLowerCase() == ".pdf")
                          this.TrustFrontImgFile = "assets/images/pdfimg.PNG"
                        else
                          this.TrustFrontImgFile = this._DomSanitizer.bypassSecurityTrustUrl(base64File);
                        this.FrontImgFile = base64File;
                      } else {
                        this.BackImgName = fileName;
                        if (validFormate.toLowerCase() == ".pdf")
                          this.TrustBackImgFile = "assets/images/pdfimg.PNG";
                        else
                          this.TrustBackImgFile = this._DomSanitizer.bypassSecurityTrustUrl(base64File);
                        this.BackImgFile = base64File;
                      }
                    } else {
                      this.cmndef.presentAlert("", this.cmndecl.LanguageJson.pages[0]['alerts'].maxfilesizalwd + " "+localStorage.imgsize+"MB", "invalid");
                    }
                  });
                } else {
                  this.cmndef.presentAlert("", this.cmndecl.LanguageJson.pages[0]['alerts'].invalidImage, "invalid")
                }

              })
              .catch(err => console.log(err));
          }
        )
        .catch(error => {
          console.log(error)
        });
    }
  }

  valadationFun(event: any, flg: any) {
    console.log(event);
    console.log(flg);
    if (flg == 'email') {
      this.newemailID = this.newemailID.replace(/[^A-Za-z0-9-@!#$%&*+./?^_`{}|]/g, '')
    }
    else if (flg == 'reemailId')
      this.reemailId = this.reemailId.replace(/[^A-Za-z0-9-@!#$%&*+./?^_`{}|]/g, '')
  }

  // For Browser
  changeListener($event, flg): void {
    let name: any;
    let validFormate: any;
    let imgname: any;
    let sizeInBytes: any;
    let stringLength: any;
    let sizeInMB: any;
    name = $event.target.files[0].name;
    this.FileSelected = flg;
    validFormate = name.substring(name.lastIndexOf("."), name.length);

    console.log(validFormate);
    if (validFormate.toLowerCase() == ".jpg" || validFormate.toLowerCase() == ".jpeg" || validFormate.toLowerCase() == ".pdf" || validFormate.toLowerCase() == ".tiff" || validFormate.toLowerCase() == ".png") {
      this.cmndef.readThis($event.target).then(data => {
        imgname = data;
        stringLength = imgname.length - imgname.indexOf("64,") + 3;
        sizeInBytes = 4 * Math.ceil((stringLength / 3)) * 0.5624896334383812;
        sizeInMB = sizeInBytes / 1000000;
        console.log(sizeInMB);
        if (Math.round(sizeInMB) <= Number(localStorage.imgsize)) {
          if (this.FileSelected == "front") {
            this.FronImgName = name;
            this.FrontImgFile = imgname;
            if (validFormate.toLowerCase() == ".pdf")
              this.TrustFrontImgFile = "assets/images/pdfimg.PNG"
            else
              this.TrustFrontImgFile = this._DomSanitizer.bypassSecurityTrustUrl(imgname);
          } else {
            this.BackImgName = name;
            this.BackImgFile = imgname;
            if (validFormate.toLowerCase() == ".pdf")
              this.TrustBackImgFile = "assets/images/pdfimg.PNG"
            else
              this.TrustBackImgFile = this._DomSanitizer.bypassSecurityTrustUrl(imgname);
          }
        } else {
          this.cmndef.presentAlert("", this.cmndecl.LanguageJson.pages[0]['alerts'].maxfilesizalwd + " "+localStorage.imgsize+"MB", "invalid");
        }
      })
    } else {
      this.cmndef.presentAlert("", this.cmndecl.LanguageJson.pages[0]['alerts'].invalidImage, "invalid")
    }
  }

}
